import React from 'react'
import { withStyles } from '@material-ui/core/styles'

import { Paragraph } from '../styleguide'

const markerSize = 32

const styles = theme => ({
  markerContainer: {
    position: 'absolute',
    zIndex: 1,
    width: markerSize,
    height: markerSize,
    objectFit: 'contain',
    border: 'solid 1px #fafafa',
    backgroundColor: '#59636d',
    paddingTop: 3,
    paddingBottom: 5,
    cursor: 'default'
  },
  labelStyle: {
    fontSize: theme.typography.pxToRem(22),
    fontWeight: 'bold',
    fontStretch: 'condensed',
    lineHeight: 1.09,
    color: '#ffffff',
    textAlign: 'center'
  }
})

const Marker = ({
  label,
  posX,
  posY,
  classes: {
    markerContainer,
    labelStyle
  }
}) => (
  <div
    className={markerContainer}
    style={{
      top: `calc(${posY}% - ${posY/100 * markerSize}px)`,
      left: `calc(${posX}% - ${posX/100 * markerSize}px)`
    }}
  >
    <Paragraph condensed className={labelStyle}>
      {label}
    </Paragraph>
  </div>
)

export default withStyles(styles)(Marker)



// WEBPACK FOOTER //
// ./src/components/Marker.js